import { brand } from "@/config/brand";

/** Shown when the app cannot start at all (for example a deploy without its settings). */
export function BootError() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-background px-6 text-center">
      <img src={brand.logoPath} alt={brand.name} className="h-9 w-auto" />
      <div className="max-w-sm">
        <h1 className="text-title3 text-ink">The app could not start</h1>
        <p className="mt-2 text-subheadline text-muted-foreground">
          Please try again in a few minutes. If you need anything now, call us at{" "}
          <a className="font-semibold text-primary" href={brand.supportPhoneHref}>
            {brand.supportPhone}
          </a>
          .
        </p>
      </div>
      <button type="button" onClick={() => window.location.reload()} className="rounded-full bg-primary px-6 py-3 text-callout font-semibold text-primary-foreground">
        Try again
      </button>
    </main>
  );
}
